import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "Teams",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { getTeams, getTeamsError, getTeamsSuccess } = slice.actions;

reducerRegistry.register("teams", reducer);
